//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'QuestionDetailItem',
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    questionNumber: {
      type: Number,
      default: 1
    },
    // normal = full owner capabilities or readonly = questions can be viewed by participants but not answered
    mode: {
      type: String,
      default: 'normal'
    },
    // Expand All / Collapse All, forwarded from CategoriesQuestions
    visible: {
      type: Boolean,
      default: false
    },
    toggleKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      referrer: null,
      // collapsed by default; Expand All/Collapse All flips this via the
      // toggleKey watcher below, same as clicking the question does
      questionOpen: false
    }
  },
  watch: {
    // toggleKey always changes (even to force the same `visible` value twice),
    // so watch it rather than `visible` directly
    toggleKey() {
      this.questionOpen = this.visible
    }
  },
  computed: {
    ...mapGetters({
      isDesktop: 'breakpoints/desktop',
      isProjectOwner: 'user/isProjectOwner',
      questions: 'questions/getQuestions',
      questionsSelected: 'questions/getQuestionsSelected',
      questionsSelectActive: 'questions/getQuestionsSelectActive',
      projectPhaseCount: 'projects/getActiveProjectPhaseCount',
      templatePhaseCount: 'templates/getActiveTemplatePhaseCount',
      isActingAsReviewer: 'user/isActingAsReviewer'
    }),
    isTemplateContext() {
      return this.referrer === 'template'
    },
    showQuestionCheckbox() {
      return this.questionsSelectActive
    },
    questionSelected: {
      get() {
        return Boolean(this.questionsSelected.find(q => q._id === this.question._id))
      },
      set(value) {
        if (value) {
          this.setQuestionsSelectedAdd({ 
            _id: this.question._id, 
            text: this.question.text,
            primaryCategory: this.question.primaryCategory,
            secondaryCategory: this.question.secondaryCategory,
            tertiaryCategory: this.question.tertiaryCategory,
            tag: this.question.tag,
            type: this.question.type,
            choices: this.question.choices,
            note: this.question.note,
            phase: this.question.phase,
            required: this.question.required,
            loisDataField: this.question.loisDataField,
            requirement: this.question.requirement
          })
        } else {
          this.setQuestionsSelectedDelete({ 
            _id: this.question._id, 
            text: this.question.text,
            primaryCategory: this.question.primaryCategory,
            secondaryCategory: this.question.secondaryCategory
          })
        }
      }
    },
    questionPhaseExceedsPhaseCount() {
      return this.referrer === 'template'
        ? this.question.phase > this.templatePhaseCount
        : this.question.phase > this.projectPhaseCount
    },
    questionPhaseExceedsTooltip() {
      return `Phase does not exist for this ${this.referrer}. Update the question to a valid phase.`
    }
  },
  mounted() {
    const route = { ...this.$route.params }
    this.referrer = route.templateid ? 'template' : 'project'
  },
  methods: {
    ...mapActions({
      deleteQuestion: 'questions/deleteQuestion',
      setLastQuestionDeleted: 'questions/setLastQuestionDeleted',
      setQuestionsSelectedAdd: 'questions/setQuestionsSelectedAdd',
      setQuestionsSelectedDelete: 'questions/setQuestionsSelectedDelete',
      updateQuestion: 'questions/updateQuestionById'
    }),
    answerTypeLabel(type) {
      let label = null
      if (type === 0) {
        label = 'Text'
      } else if (type === 1) {
        label = 'Numeric'
      } else {
        label = 'Choice'
      }
      return label
    },
    async deleteQuestionConfirm(question) {
      const h = this.$createElement
      const customMsg = h(
        'div',
        [
          'Are you sure you want to delete ',
          h('strong', `"${question.text}"? `),
          'This action removes question answers (if any) for this project and cannot be undone!'
        ]
      )
      const res = await this.$bvModal.msgBoxConfirm([customMsg], {
        title: 'Confirm Question Delete!',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelVariant: 'light',
        cancelTitle: 'NO',
        footerBgVariant: 'dark',
        headerBgVariant: 'warning',
        hideHeaderClose: true,
        centered: true
      })
      if (res) {
        await this.deleteQuestionFromProject(question._id)
      }
    },
    async deleteQuestionFromProject(questionid) {
      const res = await this.deleteQuestion(questionid)
      if (res && !this.questions.length) {
        this.setLastQuestionDeleted(true)
        this.successNotification()
      }
    },
    editQuestion(questionid) {
      const { projectid, templateid } = this.$route.params
      if (templateid) {
        this.$router.push(`/templates/${templateid}/question/${questionid}/edit-question`)
      } else if (projectid) {
        this.$router.push(`/projects/${projectid}/questions/${questionid}/edit-question`)
      }
    },
    successNotification() {
      this.$bvToast.toast('Question was deleted.', {
        autoHideDelay: 2000,
        noCloseButton: true,
        solid: true,
        toaster: 'b-toaster-top-right',
        title: 'Success',
        variant: 'success'
      })
    }
  }
}
